"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ListGroupItem", {
    enumerable: true,
    get: function() {
        return ListGroupItem;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ListGroupItem = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { children, variant = "white", sticky, noBorder = false, noMargin = false, action = false, highlighted = false, className = "", highlightColor, ...props } = param;
    const { spacers, colors, borderRadius } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement("li", {
        tabIndex: action ? 0 : undefined,
        ref: ref,
        ...props,
        className: _style.default.dynamic([
            [
                "5e3d8599acac5694",
                [
                    variant === "light" ? colors.light : colors.white,
                    sticky != null ? "sticky" : "static",
                    sticky === "top" ? "top: 0;" : "",
                    sticky === "bottom" ? "bottom: 0;" : "",
                    noMargin ? "".concat(spacers.s3, " ").concat(spacers.s5) : "".concat(spacers.s3, " ").concat(spacers.s3),
                    noBorder ? "none" : "1px solid ".concat(colors.border),
                    noMargin ? "0" : "0 ".concat(spacers.s3),
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    highlightColor !== null && highlightColor !== void 0 ? highlightColor : colors.lightHover,
                    spacers.s3,
                    spacers.s5,
                    noBorder ? "none" : "1px solid ".concat(colors.border)
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "".concat(className, " ").concat(action ? "action" : "", " ").concat(highlighted ? "highlighted" : ""))
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "5e3d8599acac5694",
        dynamic: [
            variant === "light" ? colors.light : colors.white,
            sticky != null ? "sticky" : "static",
            sticky === "top" ? "top: 0;" : "",
            sticky === "bottom" ? "bottom: 0;" : "",
            noMargin ? "".concat(spacers.s3, " ").concat(spacers.s5) : "".concat(spacers.s3, " ").concat(spacers.s3),
            noBorder ? "none" : "1px solid ".concat(colors.border),
            noMargin ? "0" : "0 ".concat(spacers.s3),
            borderRadius,
            borderRadius,
            borderRadius,
            borderRadius,
            highlightColor !== null && highlightColor !== void 0 ? highlightColor : colors.lightHover,
            spacers.s3,
            spacers.s5,
            noBorder ? "none" : "1px solid ".concat(colors.border)
        ]
    }, "li.__jsx-style-dynamic-selector{background:".concat(variant === "light" ? colors.light : colors.white, ";position:").concat(sticky != null ? "sticky" : "static", ";").concat(sticky === "top" ? "top: 0;" : "", "\n            ").concat(sticky === "bottom" ? "bottom: 0;" : "", "\n            left: 0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:").concat(noMargin ? "".concat(spacers.s3, " ").concat(spacers.s5) : "".concat(spacers.s3, " ").concat(spacers.s3), ";border-top:").concat(noBorder ? "none" : "1px solid ".concat(colors.border), ";margin:").concat(noMargin ? "0" : "0 ".concat(spacers.s3), ";-webkit-border-radius:0 0 ").concat(borderRadius, " ").concat(borderRadius, ";-moz-border-radius:0 0 ").concat(borderRadius, " ").concat(borderRadius, ";border-radius:0 0 ").concat(borderRadius, " ").concat(borderRadius, "}li.__jsx-style-dynamic-selector:first-child{border-top:none;-webkit-border-radius:").concat(borderRadius, " ").concat(borderRadius, " 0 0;-moz-border-radius:").concat(borderRadius, " ").concat(borderRadius, " 0 0;border-radius:").concat(borderRadius, " ").concat(borderRadius, " 0 0}li.highlighted.__jsx-style-dynamic-selector,li.action.__jsx-style-dynamic-selector:hover,li.action.__jsx-style-dynamic-selector:focus{outline:none;cursor:pointer;background:").concat(highlightColor !== null && highlightColor !== void 0 ? highlightColor : colors.lightHover, ";margin:0;padding:").concat(spacers.s3, " ").concat(spacers.s5, ";border-bottom:").concat(noBorder ? "none" : "1px solid ".concat(colors.border), "}li.highlighted.__jsx-style-dynamic-selector+li.__jsx-style-dynamic-selector,li.action.__jsx-style-dynamic-selector:hover+li.__jsx-style-dynamic-selector,li.action.__jsx-style-dynamic-selector:focus+li.__jsx-style-dynamic-selector{border-top:0}")));
});
ListGroupItem.displayName = "ListGroupItem";

//# sourceMappingURL=ListGroupItem.js.map